<section class="current-vets">
	<section class="current-vets__heading">
		<p
			class="current-vets__heading-text"
			data-quat="value_currentVetsPetName"
		>Vet Clinics</p>
		<button
			class="current-vets__heading-action"
			data-quat="action_addVetButton"
			(click)="handleAdd()"
		>
			<span class="current-vets__heading-action-icon">
				<svg width="40" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M13.295 20c0-3.733 3.067-6.8 6.8-6.8 3.734 0 6.8 3.067 6.8 6.8 0 3.734-3.066 6.8-6.8 6.8-3.733 0-6.8-3.066-6.8-6.8zm-1.533 0c0 4.6 3.733 8.334 8.333 8.334S28.43 24.6 28.43 20s-3.734-8.333-8.334-8.333A8.336 8.336 0 0 0 11.762 20zm9.167-.866h3.266c.467 0 .867.4.834.9 0 .5-.4.866-.867.866h-3.233v3.234c0 .5-.4.866-.867.866a.86.86 0 0 1-.867-.866v-3.267H15.93a.86.86 0 0 1-.867-.867c0-.5.4-.866.867-.866h3.266V15.9c0-.5.367-.866.867-.866s.867.4.867.866v3.234z" fill="black"/>
				</svg>
			</span>
			<span>Add Vet</span>
		</button>
	</section>
	<ng-container *ngIf="!providersList.length">
		<section class="current-vets__no-results">
			<div class="current-vets__no-results-media">
				<svg width="108" height="100" viewBox="0 0 108 100" fill="none" xmlns="http://www.w3.org/2000/svg">
					<mask id="rryr8kfkca" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="108" height="100">
						<path fill="#C4C4C4" d="M.154 0h107.692v100H.154z"/>
					</mask>
					<g mask="url(#rryr8kfkca)">
						<path d="M21.884 76.228V41.036l20-.962v36.154h-20z" fill="#CCC"/>
						<path d="M27.269 59.69V46.42h13.654v13.27H27.269z" fill="#E6E6E6"/>
						<path d="M67.269 76.228V41.036l19.038-.962v36.154H67.27z" fill="#CCC"/>
						<path d="M41.885 78.462V24.55l24.23-1.473v55.385h-24.23zM67.269 59.69V46.42h13.654v13.27H67.269z" fill="#E6E6E6"/>
						<path d="M47.269 76.228V53.92h13.654v22.308H47.269z" fill="#F7F7F7"/>
						<path d="M55.346 30.458h-3.654v6.346h-5.77v4.615h5.77v6.154H56.5V41.42h5.384v-4.615H56.5l-1.154-6.346z" fill="#F5ACA8"/>
						<path d="M16.692 39.497v-6.154l24.808-.769v6.923H16.692zM67.269 38.83v-6.154l24.808-.769v6.923H67.269z" fill="#F7F7F7"/>
						<path d="M91.334 76.114h-.001l-4.313.005-.004-3.646c0-.624-.506-1.13-1.128-1.13h-.001c-.623.001-1.127.508-1.127 1.133l.005 3.646-16.87.02-.016-14.487 11.675-.014c.596 0 1.156-.233 1.576-.656.421-.423.652-.984.651-1.582l-.013-11.81c0-.598-.233-1.16-.655-1.58a2.213 2.213 0 0 0-1.575-.654h-.003l-11.675.014-.006-4.675 16.87-.02.03 26.673c.001.624.506 1.129 1.128 1.129h.001c.623 0 1.127-.508 1.127-1.132l-.03-26.672 2.22-.002a3.115 3.115 0 0 0 3.102-3.119L92.3 34.59a3.116 3.116 0 0 0-3.107-3.112h-.005l-7.223.007c-.622 0-1.127.508-1.126 1.132 0 .624.505 1.13 1.128 1.13l7.224-.008h.001c.47 0 .852.383.853.854l.003 2.965c0 .47-.381.854-.85.855l-21.345.024-.006-4.674 9.009-.01c.623-.002 1.127-.508 1.126-1.133 0-.623-.505-1.129-1.127-1.129h-.002l-9.008.01-.006-5.307c-.001-.834-.326-1.617-.915-2.206a3.089 3.089 0 0 0-2.198-.91h-.004l-21.568.024c-.831.001-1.613.327-2.2.917a3.104 3.104 0 0 0-.91 2.207l.007 5.309-21.345.024c-.83.001-1.61.326-2.196.916a3.1 3.1 0 0 0-.907 2.204l.003 2.965c.001.833.325 1.614.913 2.202.586.586 1.365.91 2.194.91h.004l2.232-.003v3.384c0 .625.505 1.13 1.128 1.13a1.13 1.13 0 0 0 1.127-1.13V40.75l16.857-.02.006 4.675-11.675.014c-.596 0-1.156.233-1.576.656-.42.423-.652.984-.651 1.582l.013 11.81c0 .598.233 1.16.655 1.58.421.422.98.654 1.575.654h.003l11.675-.014.017 14.487-16.899.02V49.261a1.13 1.13 0 0 0-1.127-1.13c-.623 0-1.128.506-1.128 1.13v26.934l-4.283.005a1.13 1.13 0 0 0-1.127 1.132c.001.624.506 1.129 1.128 1.129h.001l74.668-.087a1.13 1.13 0 0 0 1.126-1.132c0-.623-.505-1.129-1.127-1.129zM79.512 47.62l.014 11.76-11.65.014-.014-11.76 11.65-.014zm-60.799-9.125h-.001a.85.85 0 0 1-.852-.852l-.003-2.967a.851.851 0 0 1 .85-.856l21.346-.024.005 4.674-21.345.025zm9.72 20.945-.014-11.76 11.65-.014.013 11.76-11.65.014zm13.866-33.216a.855.855 0 0 1 .857-.86l21.568-.026a.86.86 0 0 1 .858.859l.058 49.947-2.818.003-.023-19.935a3.59 3.59 0 0 0-1.028-2.525 3.475 3.475 0 0 0-2.499-1.054h-.004l-10.593.012a3.475 3.475 0 0 0-2.5 1.06 3.589 3.589 0 0 0-1.022 2.527l.023 19.936-2.82.003-.057-49.947zm5.109 30.005c0-.357.134-.692.378-.943.24-.245.556-.38.891-.38l10.594-.012h.001c.335 0 .651.134.89.378.245.25.38.584.381.942l.023 19.936-13.135.015-.023-19.936z" fill="#333"/>
						<path d="M46.663 42.382h.003l3.76-.005.004 3.77a2.11 2.11 0 0 0 2.105 2.108h.003l2.857-.004c.562 0 1.09-.22 1.488-.62.397-.398.615-.929.615-1.493l-.005-3.769 3.76-.004a2.11 2.11 0 0 0 2.103-2.113l-.003-2.865a2.1 2.1 0 0 0-.619-1.492 2.088 2.088 0 0 0-1.486-.616h-.003l-3.76.005-.004-3.77c-.001-.563-.22-1.093-.619-1.491a2.089 2.089 0 0 0-1.486-.617h-.003l-2.857.004c-.563 0-1.091.22-1.488.62a2.1 2.1 0 0 0-.615 1.492l.004 3.77-3.76.004c-.562 0-1.09.22-1.487.62-.398.4-.616.93-.615 1.493l.003 2.865c0 .563.22 1.093.618 1.491.398.398.926.617 1.487.617zm4.885-4.83a1.13 1.13 0 0 0 1.126-1.132l-.005-4.75 2.557-.003.005 4.75a1.13 1.13 0 0 0 1.128 1.129h.001l4.738-.006.003 2.564-4.738.005a1.13 1.13 0 0 0-1.126 1.132l.005 4.75-2.557.002-.005-4.749c-.001-.624-.506-1.129-1.128-1.129h-.001l-4.738.006-.003-2.564 4.738-.005z" fill="#333"/>
					</g>
				</svg>
			</div>
			<p class="current-vets__no-results-heading">Why Add Vet Clinics?</p>
			<p class="current-vets__no-results-copy">
				Adding your vet clinics here before your first claim will help us process your claims faster!
			</p>
		</section>
	</ng-container>
	<ng-container *ngIf="!!providersList.length">
		<mat-table [dataSource]="providersList">
			<!-- Vet Clinic Name Column -->
			<ng-container matColumnDef="name">
				<mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
				<mat-cell *matCellDef="let vet">
					<p
						class="vet-list__clinic"
						[ngClass]="{'is--mobile-view': isMobileView}"
					>
						<span
							class="vet-list__clinic-name"
							[ngClass]="{'is--mobile-view': isMobileView}"
						>{{ vet.name }}</span>
						<span
							*ngIf="isMobileView"
							class="vet-list__clinic-name-address"
						>{{ vet.cityState }}</span>
					</p>
				</mat-cell>
			</ng-container>
			<!-- City/State Column -->
			<ng-container matColumnDef="cityState">
				<mat-header-cell *matHeaderCellDef>City/State</mat-header-cell>
				<mat-cell *matCellDef="let vet">{{ vet.cityState || 'City/State' }}</mat-cell>
			</ng-container>
			<!-- Action Column -->
			<ng-container matColumnDef="action">
				<mat-header-cell *matHeaderCellDef></mat-header-cell>
				<mat-cell *matCellDef="let vet; let i = index">
					<button
						type="button"
						class="vet-list__action"
						[attr.data-quat]="'action_editVetButton' + i"
						(click)="handleEdit(vet)"
					>Edit</button>
				</mat-cell>
			</ng-container>

			<mat-header-row
				*matHeaderRowDef="displayedColumns"
				class="vet-list__column-headers"
				[ngClass]="{'is--mobile-view': isMobileView}"
			></mat-header-row>
			<mat-row
				*matRowDef="let row; let i = index; columns: displayedColumns;"
				[ngClass]="{'is--mobile-view': isMobileView}"
				[attr.data-quat]="'value_currentVetRow' + i"
			></mat-row>
		</mat-table>
	</ng-container>
</section>
